/* eslint-disable camelcase */
import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useState } from 'react';

import MessageInfo from '../../../components/messageInfo/MessageInfo';
import { ScorecardRulesHeaderTable } from '../../../components/scorecardRulesHeaderTable/ScorecardRulesHeaderTable';
import { ColumnData } from '../../../utils/types';
import { useGetMetricHeaderInfoQuery, useGetScorecardHeaderInfoQuery } from './ScorecardRulesHeaderSlice';

export interface ScorecardRulesHeaderProps {
    inputYear?: number;
    inputMonth?: number;
    scorecardVersionId?: number;
}
interface Metric {
    name: string;
    code: string;
}

export const ScorecardRulesHeader = ({
    inputYear,
    inputMonth,
    scorecardVersionId,
}: ScorecardRulesHeaderProps) => {
    const [scoreCardData, setScoreCardData] = useState<ColumnData[]>([]);
    const [metricData, setMetricData] = useState<ColumnData[]>([]);
    const [metricsArray, setMetricsArray] = useState<Metric[]>([]);

    const [selectedMetric, setSelectedMetric] = useState(0);

    const { data: ScorecardHeaderInfoData } = useGetScorecardHeaderInfoQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId,
        },
        {
            skip: !inputYear || !inputMonth || !scorecardVersionId,
        }
    );
    const { data: MetricHeaderInfoData } = useGetMetricHeaderInfoQuery(
        {
            metricId: selectedMetric,
            scorecardVersionId,
        },
        {
            skip: !selectedMetric || !scorecardVersionId,
        }
    );

    useEffect(() => {
        if (ScorecardHeaderInfoData?.data?.length > 0) {
            const metricsItem = ScorecardHeaderInfoData?.data?.find(
                (item: { column_name: string }) => item.column_name === 'metrics'
            );
            const newData = ScorecardHeaderInfoData?.data.filter(
                (item: { column_name: string }) => item.column_name !== 'metrics'
            );
            /* eslint-disable prefer-const*/
            let ScorecardData = newData?.map((item: any) => {
                let newHeader = { column_name: '', column_value: '' };
                newHeader.column_name = item?.column_name;
                newHeader.column_value = item?.column_value?.replace(/~/g, ', ');
                return newHeader;
            });
            setScoreCardData(ScorecardData);

            if (metricsItem?.column_value) {
                const metricsArray: Metric[] = metricsItem?.column_value.split('~').map((metric: string) => {
                    const metricArr = metric.split('-');
                    return { name: metricArr[0].trim(), code: metricArr[metricArr.length - 1].trim() };
                });
                setMetricsArray(metricsArray);
            }
        }
    }, [inputYear, inputMonth, scorecardVersionId, ScorecardHeaderInfoData]);

    useEffect(() => {
        setMetricData([]);
        if (MetricHeaderInfoData?.data?.length > 0) {
            setMetricData(MetricHeaderInfoData?.data);
        }
    }, [selectedMetric, scorecardVersionId, MetricHeaderInfoData]);

    if (ScorecardHeaderInfoData?.data?.length > 0) {
        return (
            <div className="card-body">
                <div className="row">
                    <div className="col-md-6 border-end">
                        <h4 className="ms-2">
                            <p> Version :{scorecardVersionId}</p>
                        </h4>
                        <ScorecardRulesHeaderTable data={scoreCardData} />
                    </div>
                    <div className="col-md-6">
                        <Dropdown
                            value={selectedMetric}
                            options={metricsArray}
                            onChange={(e: any) => setSelectedMetric(e.value)}
                            optionLabel={'name'}
                            optionValue={'code'}
                            placeholder="Select a Metric"
                            className="custom-dropdown"
                        />
                        <ScorecardRulesHeaderTable data={metricData} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="col-12">
            <h6 className="card-title">Scorecard Header Info</h6>
            <hr className="mt-2" />
            <MessageInfo
                title="No results found."
                message="Try adjusting the month or scorecard filter above."
                rowHeight="308px"
            />
        </div>
    );
};
